import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import { logout } from './authReducer'

interface LoginState {
  isAuthenticated: boolean
  email: string
  passwordChange: boolean
  qrSecret: string
  mfaPreferred: boolean
  newPassword: boolean
  session: string
  loading: boolean
  loggedInUserRole: string
  loggedInUserCognitoUuid: string
  loggedInUserName: string
  loggedInUserInfoUuid: string
  loggedInUserTenantID: string
  loggedInUserID: string
  loggedInUserStatus: string
  loggedInUserEmail: string
  loggedInUserDeviceID: string
  loggedInUserMobilenumber: string
  loggedInUserAddressOne:string
  loggedInUserAddressTwo:string
  loggedInUserCountry:string
  loggedInUserCity:string
  loggedInUserState:string
  loggedInUserPincode:string
  loggedInHospitalName:string
  loggedInHospitalBranch:string
  loggedInHospitalGstNo:string
  loggedInHospitalWebSite:string
  userTableUuid:string
  hospitalTableUuid:string
  profileImageName: string
  profileImageUrl: string
  oldProfileImageName:string
  hospitalLogoUrl:string
  loggedInHospitalId:string
  loggedInHospitalUuId:string
  hospitalDeviceId:string
  hospitalBlocked:Boolean,
  language:string
}

const initialState: LoginState = {
  isAuthenticated: false,
  email: '',
  passwordChange: false,
  qrSecret: '',
  mfaPreferred: false,
  newPassword: false,
  session: '',
  loading: true,
  loggedInUserRole: '',
  loggedInUserCognitoUuid: '',
  loggedInUserName: '',
  loggedInUserTenantID: '',
  loggedInUserInfoUuid: '',
  loggedInUserID: '',
  loggedInUserStatus: '',
  loggedInUserEmail: '',
  loggedInUserDeviceID: '',
  loggedInUserMobilenumber: '',
  loggedInUserAddressOne:'',
  loggedInUserAddressTwo:'',
  loggedInUserCountry:'',
  loggedInUserCity:'',
  loggedInUserState:'',
  loggedInUserPincode:'',
  loggedInHospitalName:'',
  loggedInHospitalId:'',
  loggedInHospitalBranch:'',
  loggedInHospitalGstNo:'',
  loggedInHospitalWebSite:'',
  userTableUuid:'',
  hospitalTableUuid:'',
  profileImageName:'',
  profileImageUrl:'',
  oldProfileImageName: '',
  hospitalLogoUrl: '',
  loggedInHospitalUuId:'',
  hospitalDeviceId:'',
  hospitalBlocked: false,
  language:''
}

const loginSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess(state) {
      state.isAuthenticated = true
    },
    logoutSuccess(state) {
      state.isAuthenticated = false
    },
    setLoginEmail(state, action: PayloadAction<string>) {
      state.email = action.payload
    },
    setPasswordChange(state, action: PayloadAction<boolean>) {
      state.passwordChange = action.payload
    },
    setQrSecret(state, action: PayloadAction<string>) {
      state.qrSecret = action.payload
    },
    setMfaPreferred(state, action: PayloadAction<boolean>) {
      state.mfaPreferred = action.payload
    },
    setNewPassword(state, action: PayloadAction<boolean>) {
      state.newPassword = action.payload
    },
    setSession(state, action: PayloadAction<string>) {
      state.session = action.payload
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setLoggedInUserRole(state, action: PayloadAction<string>) {
      state.loggedInUserRole = action.payload
    },
    setLoggedInUserCognitoUuid(state, action: PayloadAction<string>) {
      state.loggedInUserCognitoUuid = action.payload
    },
    setLoggedInUserName(state, action: PayloadAction<string>) {
      state.loggedInUserName = action.payload
    },
    setLoggedInUserInfoUuid(state, action: PayloadAction<string>) {
      state.loggedInUserInfoUuid = action.payload
    },
    setLoggedInUserTenantID(state, action: PayloadAction<string>) {
      state.loggedInUserTenantID = action.payload
    },
    setLoggedInUserID(state, action: PayloadAction<string>) {
      state.loggedInUserID = action.payload
    },
    setLoggedInUserStatus(state, action: PayloadAction<string>) {
      state.loggedInUserStatus = action.payload
    },
    setLoggedInUserEmail(state, action: PayloadAction<string>) {
      state.loggedInUserEmail = action.payload
    },
    setLoggedInUserDeviceID(state, action: PayloadAction<string>) {
      state.loggedInUserDeviceID = action.payload
    },
    setLoggedInUserMobileNumber(state, action: PayloadAction<string>) {
      state.loggedInUserMobilenumber = action.payload
    },
    setLoggedInUserAddressOne(state, action: PayloadAction<string>) {
      state.loggedInUserAddressOne = action.payload
    },
    setLoggedInUserAddressTwo(state, action: PayloadAction<string>) {
      state.loggedInUserAddressTwo = action.payload
    },
    setLoggedInUserCity(state, action: PayloadAction<string>) {
      state.loggedInUserCity = action.payload
    },
    setLoggedInUserState(state, action: PayloadAction<string>) {
      state.loggedInUserState = action.payload
    },
    setLoggedInUserCountry(state, action: PayloadAction<string>) {
      state.loggedInUserCountry = action.payload
    },
    setLoggedInUserPincode(state, action: PayloadAction<string>) {
      state.loggedInUserPincode = action.payload
    },
    setLoggedInHospitalName(state, action: PayloadAction<string>) {
      state.loggedInHospitalName = action.payload
    },
    setLoggedInHospitalId(state, action: PayloadAction<string>) {
      state.loggedInHospitalId = action.payload
    },
    setLoggedInHospitalBranch(state, action: PayloadAction<string>) {
      state.loggedInHospitalBranch = action.payload
    },
    setLoggedInHospitalGstNo(state, action: PayloadAction<string>) {
      state.loggedInHospitalGstNo = action.payload
    },
    setLoggedInHospitalUuId(state, action: PayloadAction<string>) {
      state.loggedInHospitalUuId = action.payload
    },
    setLoggedInHospitalWebSite(state, action: PayloadAction<string>) {
      state.loggedInHospitalWebSite = action.payload
    },
    setHospitalTableUuid(state, action: PayloadAction<string>) {
      state.hospitalTableUuid = action.payload;
    },
    setUserTableUuid(state, action: PayloadAction<string>) {
      state.userTableUuid = action.payload;
    },
    setProfileImageName(state, action: PayloadAction<string>) {
      state.profileImageName = action.payload;
    },
    setProfileImageUrl(state, action: PayloadAction<string>) {
      state.profileImageUrl = action.payload;
    },
    setOldProfileImageName(state, action: PayloadAction<string>) {
      state.oldProfileImageName = action.payload;
    },
    setHospitalLogoUrl(state, action: PayloadAction<string>) {
      state.hospitalLogoUrl = action.payload;
    },
    setHospitalDeviceID(state, action: PayloadAction<string>) {
      state.hospitalDeviceId = action.payload;
    },
    setHospitalBlocked(state, action: PayloadAction<Boolean>) {
      state.hospitalBlocked = action.payload;
    },
    setLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      return { ...initialState, loading: state.loading };
    });
  },
})

export const { loginSuccess,setLoggedInHospitalId, setHospitalBlocked,setProfileImageUrl, setLoggedInUserCognitoUuid, setLoggedInHospitalUuId,setHospitalDeviceID, setHospitalLogoUrl,setLoggedInHospitalWebSite,logoutSuccess,setHospitalTableUuid,setProfileImageName,setOldProfileImageName,setLoggedInUserDeviceID,setUserTableUuid,setLoggedInUserAddressOne,setLoggedInUserAddressTwo,setLoggedInUserState,setLoggedInUserCity,setLoggedInUserCountry,setLoggedInHospitalName,setLoggedInHospitalBranch,setLoggedInHospitalGstNo,setLoggedInUserMobileNumber,setLoggedInUserPincode, setLoginEmail, setPasswordChange, setQrSecret, setMfaPreferred, setNewPassword, setSession, setLoading, setLoggedInUserRole, setLoggedInUserName, setLoggedInUserInfoUuid, setLoggedInUserTenantID, setLoggedInUserID, setLoggedInUserStatus,setLoggedInUserEmail,setLanguage } = loginSlice.actions

export default loginSlice.reducer
